import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("OK");
      nav("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="register-page">
      <Header />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5 md:col-start-2">
          <div className="font-mono-tech text-xs tracking-[0.3em] uppercase text-[#D90429] mb-6">
            · NUEVA INSCRIPCIÓN
          </div>
          <h1 className="font-serif-display text-5xl md:text-6xl font-bold tracking-tighter leading-none mb-10">
            {t("auth_register_title")}
          </h1>
          <form onSubmit={submit} className="space-y-8" data-testid="register-form">
            <div>
              <label className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] block mb-2">
                {t("auth_name")}
              </label>
              <input
                data-testid="register-name"
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full bg-transparent border-b border-[#0A0A0A] px-0 py-3 text-lg focus:outline-none focus:border-[#D90429]"
                autoComplete="name"
              />
            </div>
            <div>
              <label className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] block mb-2">
                {t("auth_email")}
              </label>
              <input
                data-testid="register-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b border-[#0A0A0A] px-0 py-3 text-lg focus:outline-none focus:border-[#D90429]"
                autoComplete="email"
              />
            </div>
            <div>
              <label className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] block mb-2">
                {t("auth_password")} ≥ 6
              </label>
              <input
                data-testid="register-password"
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border-b border-[#0A0A0A] px-0 py-3 text-lg focus:outline-none focus:border-[#D90429]"
                autoComplete="new-password"
              />
            </div>
            <button
              data-testid="register-submit"
              disabled={loading}
              className="w-full bg-[#0A0A0A] text-white py-4 font-mono-tech text-xs uppercase tracking-[0.3em] border border-[#0A0A0A] hover:bg-[#D90429] hover:border-[#D90429] transition-colors disabled:opacity-50"
            >
              {loading ? "···" : t("auth_submit_register")}
            </button>
            <div className="font-mono-tech text-xs uppercase tracking-widest text-[#404040]">
              {t("auth_have_account")}{" "}
              <Link to="/login" className="underline underline-offset-4 hover:text-[#D90429]" data-testid="link-to-login">
                {t("nav_login")}
              </Link>
            </div>
          </form>
        </div>
        <aside className="hidden md:flex md:col-span-5 bg-[#0A0A0A] text-white p-12 flex-col justify-between border-t-4 border-[#D90429]">
          <div className="font-mono-tech text-[10px] tracking-[0.3em] uppercase opacity-60">
            · CUENTA · ACADÉMICO · LIBRE
          </div>
          <div>
            <h2 className="font-serif-display text-4xl font-bold leading-tight mb-6">
              Acceso completo al laboratorio analítico.
            </h2>
            <ul className="space-y-3 font-mono-tech text-xs uppercase tracking-widest opacity-80">
              <li>· 03 modelos LLM disponibles</li>
              <li>· Texto · Archivo · Audio</li>
              <li>· Historial completo de análisis</li>
              <li>· Análisis multilingüe ES / EN</li>
            </ul>
          </div>
          <div className="font-mono-tech text-[10px] tracking-[0.3em] uppercase opacity-60">
            🔬 GalascioDAS™
          </div>
        </aside>
      </div>
    </div>
  );
}
